<app-form-input [label]="'Le présent avis constitue une mise en concurrence'" [disabled]="disabled" [checkboxDestination]="'object'" [name]="getUid()+'_SepAtt_miseEnConcurrence'"
	[parentForm]="parentForm" [rule]="''" [type]="'checkbox'" [value]="initial?.avisConcerne?.mise_En_Concurrence">
</app-form-input>
